import React from "react";
 import { HiOutlineViewList } from 'react-icons/hi';
  import './style.css'; 
  let buyermotivation=(props)=>
   { 
     
  return(


    
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  
  Buyer Motivation parity Score
  
  </h4>
        <br></br>
        <h6 id="h62">
  Buyer motivation parity inform about how like a target coustomer is to pay for Services you intend to provide
  </h6>
        <h6 id="h6">
  How important and how urgent is it for that coustomer to solve the problem for which you Provide Solution?
  </h6>
        <h6 id="h6">
  And What are your Coustomer's Cureent oprions to solve the problem , Reger to the Chart
  </h6>
        <h6 id="h6">
  Pick a Quardrant and then pick a Category 
  </h6>
        <h6 id="h6">
  Enter the score in the Picked box Below
  </h6>
        <div id='divL'>
          <input type='text' id="paddingText"></input>
        </div>
        <div id='flexLef'>
          <button className="button2" onClick={()=>props.history.push('/couActStack')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/problemScorecard')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>
  )
   } 
   export default buyermotivation;